import React from "react"
import PropTypes from 'prop-types'
import { Link } from "react-router-dom"
import { Row, Col, BreadcrumbItem } from "reactstrap"
import './breadcrumb.scss'

const Breadcrumb = props => {
  return (
    <Row>
      <Col xs={12}>
        <div className="d-sm-flex align-items-center justify-content-between">
          <h4 className="mb-sm-0 font-size-18 pb-3" >{props.breadcrumbItem}</h4>
          {/* <div className="page-title-right">
            <ol className="breadcrumb m-0">
              <BreadcrumbItem><Link to="#">{props.title}</Link></BreadcrumbItem>
              <BreadcrumbItem active>{props.breadcrumbItem}</BreadcrumbItem>
            </ol>
          </div> */}
        </div>
      </Col>
    </Row>
  )
}

Breadcrumb.propTypes = {
  breadcrumbItem: PropTypes.string,
  title: PropTypes.string
}

export default Breadcrumb
